export default __webpack_public_path__ + "static/media/img4-carousel.d99d2ec0.webp";